import { Typography } from 'antd'
import { CIMSPage } from '@cims-online/shared'
import ProjectLink from 'components/ProjectLink'

const GroupFallback: React.FC = () => {
  return (
    <Typography.Paragraph>
      No{' '}
      <ProjectLink item={CIMSPage.RFIResponseDisciplines}>
        Response Disciplines
      </ProjectLink>{' '}
      have been configured for this Project
    </Typography.Paragraph>
  )
}

export default GroupFallback
